<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Favorecido</option>
                                </select>
                            </div>
                            <div class="col-sm-4 col-md-4 col-lg-4">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
                            <div class="col-sm-4 col-md-2 col-lg-2">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo" @change="mtdlimpar_listagem()">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>
							<div class="col-sm-4 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-4 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>
                            
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstrecibos"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>

                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>

                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>

                                    <template slot="opcoes" slot-scope="item">
                                        <div class= "row" style="width: 145px; justify-content: center;">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn"   @click.prevent="mtdalterar(item.row)"><i class="fa fa-edit"></i></button>
                                        <button  type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="fa fa-trash"></i></button>
                                        <button style=" background-color: #006f7a ;" type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn"   @click.prevent="mtdimprimir(item.row)"><i class="fa fa-print"></i></button>
                                        </div>
                                    </template>

                                    <template slot="price" slot-scope="item">
										<span style="color: #5c8f94; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(item.row.valor), 2) }}</span>
									</template>


                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstrecibos.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">

                            <!-- codigo -->
                            <div class="col-sm-10 col-md-1 col-lg-1" style="width: auto;">
                                <label for="edid">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" disabled/>
                            </div>
							 <!-- sect filial usando select 2 -->
                            <div class="col-sm-10 col-md-3 col-lg-3">
								<label for="cbfilial">*Filial:</label>
								<select id="cbfilial" v-model="vidfilial" v-bind:disabled="ativafil"
										data-placeholder="Selecione uma opção" data-allow-clear="true"
										style="width:100%;">
								</select>
							</div>

                                  <!-- Emitente -->
							<div class="col-sm-10 col-md-4 col-lg-4">
                                <label for="eddescricao">*Emitente:</label>
                                <input type="text" v-model="vemitente" v-bind:disabled="ativadesativa"
                                       class="form-control form-control-sm" id="eddescricaod" maxlength="50">
                            </div>

                              <!-- CPF/CNPJ EMITENTE -->
							<div class="col-sm-10 col-md-2 col-lg-2">
								<label for="edcpf">*CPF/CNPJ (emitente)</label>
								<input type="text" v-model="vcnpjcpfe" v-bind:disabled="ativadesativa"
								class="form-control form-control-sm" id="edcpf" 
								v-mask="['###.###.###-##', '##.###.###/####-##']">
							</div>

                             <!-- RG -->
							<div class="col-sm-10 col-md-2 col-lg-2">
								<label for="edrg">*RG/IE (emitente)</label>
								<input type="text" v-model="vierge" v-bind:disabled="ativadesativa"
								class="form-control form-control-sm" id="edrg" maxlength="20">
							</div>
                            
                             <!-- favorecido -->
							<div class="col-sm-10 col-md-4 col-lg-4">
                                <label for="eddescricao">*Favorecido:</label>
                                <input type="text" v-model="vfavorecido" v-bind:disabled="ativadesativa"
                                       class="form-control form-control-sm" id="eddescricao" maxlength="50">
                            </div>

                             <!-- CPF/CNPJ  -->
							<div class="col-sm-10 col-md-2 col-lg-2">
								<label for="edcpf">*CPF/CNPJ</label>
								<input type="text" v-model="vcnpjcpf" v-bind:disabled="ativadesativa"
								class="form-control form-control-sm" id="edcpf" 
								v-mask="['###.###.###-##', '##.###.###/####-##']">
							</div>

                             <!-- RG -->
							<div class="col-sm-10 col-md-2 col-lg-2">
								<label for="edrg">*RG/IE</label>
								<input type="text" v-model="vierg" v-bind:disabled="ativadesativa"
								class="form-control form-control-sm" id="edrg" maxlength="20">
							</div>

                             <!-- Referente a  -->
                            <div class="col-sm-12 col-md-8 col-lg-8">
                                <label for="eddescricao">*Referente a:</label>
                                <input type="text" v-model="vreferente" v-bind:disabled="ativadesativa"
                                       class="form-control form-control-sm"  maxlength="50">
                            </div>

                             <!-- dt cadastro -->
                           <div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtemissao">*Dt. Emissão:</label>
								<div class="input-group">
									<date-picker id="eddtemissao" v-model="vdtemissao" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>              
                            </div>
                            <!-- valor -->
                           
                             <div class="col-sm-12 col-md-2 col-lg-2">
                              <label for="edvltabela">*Valor:</label>
                               <money type="text" class="form-control form-control-sm" id="edvltabela"
                                    :config="money"  v-model="vmoney" v-bind="money" v-bind:disabled="ativadesativa"
                                     data-bv-group=".group" style="text-align:right; background: none; color:darkgreen; font-weight:bold;">
                                </money>
                               </div>
                             <!-- Confirmação -->
                            <div class="col-sm-10 col-md-10 col-lg-10">
                                <label for="eddescricao">*Texto confirmação:</label>
                                <input type="text" v-model="vconfirm" v-bind:disabled="ativadesativa"
                                       class="form-control form-control-sm" id="eddescricao" maxlength="50">
                            </div>
                            <div class="col-sm-10 col-md-2 col-lg-2">            
                                <br>
                                    <button type="button" @click.prevent="mtdtrocar()"
                                                class="btn btn-success btn-sm btn-block"
                                                ><i class="fa fa-retweet"></i> Inverter dados
                                    </button>
                             </div>
							<!-- Obs -->
                           <div class="col-sm-12 col-md-12 col-lg-12">
								<label for="edobs">Observações:</label>
								<div class="form-group">
									<textarea class="form-control" v-bind:disabled="ativadesativa" 
										rows="6" id="edobs" v-model="vobs" style="text-transform: uppercase;"></textarea>
								</div>
							</div>		
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'

    export default {
        name: 'cadrecibo',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb
        },
        data: function() {
            return {
                lstrecibos  : [],
                pfiltro      : 1,
                pconteudo    : '',
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,
                hab_desab_periodo : true,
                pdtini        : util.DataAtual(true),
                pdtfim        : util.DataAtual(true),


                //variáveis do crud
                pfiltroperiodo      :  0,
                opcrud              :  0,
                vtipopessoa         :  0,
                vid                 : '',
                vidfilial           : null,
                vfavorecido         : '',
                vemitente           : '',
                vcnpjcpf            : '',
                vierg               : '',
                vcnpjcpfe           : '',
                vierge              : '',
                vreferente          : '',
                vmoney              : 0 ,
                vconfirm            : 'que pelo qual dou(amos) plena e geral quitacao.',
                vobs                : '',
                vdtemissao : util.DataAtual(),

                //variável para habilitação dos campos
                ativadesativa       : true,
                ativafil            : true,   

                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'RECIBO',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-opcoes",
                        sort: true
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",

                    },
                    {
                        label: "Favorecido",
                        name: "favorecido",
                        //initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Emitente",
                        name: "emitente",
                        // initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Data",
                        name: "dtemissao",
                        // initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Valor",
                        name: "valor",
                        // initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "price"
                    }
                  
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false,                    
                },				
                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : true,
                    locale           : 'pt-BR'
                },                
				money				: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : 'R$',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
			mtdformatadatagravar(dtformatar){
				let strret = dtformatar.replace(/\D/g, "");
				return strret.substring(0,2)+'/'+strret.substring(2,4)+'/'+strret.substring(4);
			},            
            mtdfiltropesquisa(){

                        let rfiltro = '';
                        if (parseInt(this.pfiltro) === 0){
                            rfiltro = this.pconteudo === '' ? '' : ' and r.id='+this.pconteudo;
                        }else{
                            rfiltro = this.pconteudo === '' ? '' : ' and upper(r.favorecido) like upper("'+this.pconteudo+'%")';
                        }
                            if(parseInt(this.pfiltroperiodo) === 1){
					        rfiltro = rfiltro + ' and r.dtemissao between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';
				        }
                        return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadrecibo.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregarecibo(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregarecibo(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadrecibo.php');
                retorno.then(function (response) {
                    vself.lstrecibos = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstrecibos = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();

            
              
                this.vid                 = '';
                this.vidfilial           = null;
                this.vfavorecido         = '';
                this.vemitente           = '';
                this.vcnpjcpf            = '';
                this.vierge              = '';
                this.vcnpjcpfe           = '';
                this.vierg               = '';
                this.vreferente          = '';
                this.vmoney              = 0 ;
                this.vconfirm            = 'que pelo qual dou(amos) plena e geral quitacao.';
                this.vobs                = '';
                this.vdtemissao = util.DataAtual();
            

            },
            mtdtrocar(){
                // CPF/CNPJ
                var changecpf1 = this.vcnpjcpf;
                var changecpf2 = this.vcnpjcpfe;
                this.vcnpjcpf = changecpf2;
                this.vcnpjcpfe = changecpf1;
                // RG/IE
                var changeRG1 = this.vierg;
                var changeRG2 = this.vierge;
                this.vierg = changeRG2;
                this.vierge = changeRG1;
                 // muda dados
                var changecamp1 = this.vemitente;
                var changecamp2 = this.vfavorecido;
                this.vemitente   = changecamp2;
                this.vfavorecido = changecamp1;
                 
            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#cbfilial').focus();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvperfil"]').tab('show');
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('030Z.050Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE RECIBO ';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.ativafil   = false;
                    this.vidfilial  = null;
                    $('#cbfilial').val(null).trigger('change');
                    $('#cbfilial').select2('open');
                    this.mtdpreparacrud(1);
                    
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstrecibos = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and r.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadrecibo.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('030Z.050Z.020Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE RECIBO';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.vidfilial = null;
                    this.ativafil = true;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('030Z.050Z.030Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE RECIBO';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativafil = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdigualarcampos(registro){
                this.vid                 = registro.id;
                this.vidfilial           = registro.idfilial;
                this.vdescfilial         = registro.descfilial;

                this.vfavorecido         = registro.favorecido;
                this.vemitente           = registro.emitente;
                this.vcnpjcpf            = registro.cnpjcpf;
                this.vierg               = registro.ierg;
                this.vcnpjcpfe           = registro.cnpjcpfe;
                this.vierge              = registro.ierge;
                this.vreferente          = registro.referente;   
                this.vmoney              = parseFloat(registro.valor);
                this.vdtemissao          = registro.dtemissao;
                this.vconfirm            = registro.confirm;
                this.vobs                = registro.obs;

                    
                    var   deffilial          = new Option(registro.descfilial, registro.idfilial, true, true);
                $('#cbfilial').append(deffilial).trigger('change');
                
                

            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'                : this.vid,
                    'favorecido'        : this.vfavorecido,
                    'emitente'          : this.vemitente,
                    'cnpjcpf'           : this.vcnpjcpf,
                    'ierg'              : this.vierg,
                    'cnpjcpfe'          : this.vcnpjcpfe,
                    'ierge'             : this.vierge,            
                    'referente'         : this.vreferente,               
                    'valor'             : this.vmoney,               
                    'dtemissao'         : this.mtdformatadatagravar(this.vdtemissao),
                    'confirm'           : this.vconfirm,
                    'obs'               : this.vobs,
                    'idfilial'          : this.vidfilial,
                    
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '001Z.003Z.001Z' : parseInt(this.opcrud) === 2 ? '001Z.003Z.002Z' : '001Z.003Z.003Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadrecibo.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregarecibo(1);
                       

                        
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdselect2_def(vidfilial){
                let vself = this;
                $("#cbfilial").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 300,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbfiliais',
								c1: 'codfil',
								c2: 'descfil'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    //abixo função para que os dados da filial seja carraegada em seus referentes campos
					vself.vidfilial = $("#cbfilial").val();
                   
					let parametros  = [
						{parametro: 'op',               valor : 'pegadado'},
                        {parametro: 'idclientesac',    valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'idfilial',         valor : parseInt(vself.vidfilial)}
						
					];
					let retorno    = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadrecibo.php');
					retorno.then(function (response) {

                           if(vself.opcrud != 2){
                        
							let filis = response.data[0];							
							
							vself.vemitente    = filis.descfil;
                            vself.vcnpjcpfe    = filis.cnpj;
                            vself.vierge       = filis.ie;
							
                           }
							
						
					}).catch(function (response) {
						console.log(response.message)
					});
				});  
                loader.hide();	
			},
            mtdformatavalordecimal(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
			},
            mtdimprimir(item){
                if (!util.opcaousuario('030Z.050Z.040Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                let vself = this;
                vself.mtdlocalizaregistro(item.id);
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Deseja imprimir o recibo?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                
                                
                                 $.confirm({
                    title: 'Confirmação!',
                    content: 'Deseja imprimir em 2 (duas) vias?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                
                                window.open(vself.$store.state.configpaths.pathcontrole+'rtimprimereciboavulso.php?idclientesac='+vself.$store.state.usuario.idclientesac+'&idrecibo='+item.id+'&qdvias=2', '_blank');
                            
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                //$('#btgravar').focus();
                                $('.btn-blue').prop('disabled', true);

                                window.open(vself.$store.state.configpaths.pathcontrole+'rtimprimereciboavulso.php?idclientesac='+vself.$store.state.usuario.idclientesac+'&idrecibo='+item.id+'&qdvias=1', '_blank');
                            }
                        }
                    }
                });
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                //$('#btgravar').focus();
                                $('.btn-blue').prop('disabled', true);

                                
                            }
                        }
                    }
                });
        }},
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('030Z.050Z', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);
                        vself.mtdexecutapesquisa();
                        vself.mtdselect2_def();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
                 
            return(this.vfavorecido        === '')
                ||(this.vemitente          === '')
                ||(this.vcnpjcpf           === '')
                ||(this.vcnpjcpfe          === '')
                ||(this.vidfilial          === null)   
                ||(this.vierg              === '')
                ||(this.vierge             === '')
                ||(this.vconfirm           === '')
                ||(this.vmoney             === 0 )
                ||(this.vdtemissao         === '')
                ;
                    
            },

            selecionaperiodo() {
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
            }
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregarecibo(val);
            }
        }
    }
</script>
<style>
    .def-col-cod{
        width: 80px !important;
    }

    .def-col-opcoes{
        width: 90px !important;
    }

    #btclonarperfilusuario{
        cursor: pointer;
        font-weight: bold;
        font-size: 18px;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodosopusuario{
        font-weight: bold;
        font-size: 18px;
        padding-right: 10px;
        cursor: pointer;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodosopusuario:hover{
        color: #666666;
        transition: .35s;
    }

    #btmarcartodfiliais{
        font-weight: bold;
        font-size: 18px;
        padding-right: 10px;
        cursor: pointer;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodfiliais:hover{
        color: #666666;
        transition: .35s;
    }
    #btclonarperfilusuario:hover{
        color: #666666;
        transition: .35s;
    }
</style>